import './ScrollingCardsSkeleton.scss'

import cn from 'classnames'
import CardSkeleton from '../CardSkeleton'

/**
 * Empty Card Skeleton component. Used to display skeleton cards while loading
 */
export default function ScrollingCardsSkeleton({ className, count = 3 }) {
  // Create an array of the number of cards we want to display
  const cards = Array.from(Array(count).keys())
  return (
    <div className={cn('scrolling-cards-skeleton', className)}>
      <div className='scrolling-cards-skeleton-cards'>
        {cards.map((_, index) => (
          <CardSkeleton key={index} />
        ))}
      </div>
    </div>
  )
}
